var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "23.255%",
    y1: "23.255%",
    x2: "123.445%",
    y2: "123.445%",
    id: "ox8okk8sfa"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFE9F2",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9EA7B0",
    offset: "99.8%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "23.086%",
    y1: "33.945%",
    x2: "91.079%",
    y2: "88.941%",
    id: "fx9zvvi59b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F44F5A",
    offset: ".8%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE3D4A",
    offset: "44.7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E52030",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "35.821%",
    y1: "29.691%",
    x2: "96.129%",
    y2: "89.52%",
    id: "yvlt759fnc"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D61A9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16528C",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 16c0-8.836-7.164-16-16-16S0 7.164 0 16s7.164 16 16 16 16-7.164 16-16z",
    fill: "url(#ox8okk8sfa)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m6.328 13.677 3.484-5.369.472.306L6.8 13.98zM3.834 19.942l.538-.347 3.478 5.372-.534.347zM22.931 7.792l.535-.347 3.54 5.425-.537.35zM5.075 12.902l3.484-5.37.469.304-3.484 5.369zM23.556 11.52l.469-.306 1.613 2.484-.472.306zM25.962 22.114l1.613-2.484.469.307-1.613 2.481zM6.91 22.008l.468-.303 1.613 2.481-.469.307zM26.047 9.933l.469-.307 1.622 2.476-.47.306zM23.497 20.495l1.613-2.484.468.307-1.612 2.481zM24.75 21.27l1.618-2.481.534.35-1.616 2.482zM21.718 8.614l.47-.306 1.62 2.475-.468.307zM24.084 24.977l1.597-2.494.472.303-1.6 2.49zM5.082 19.092l.537-.347 1.6 2.49-.537.347zM24.213 7.017l.469-.31 1.624 2.475-.468.307zM21.606 23.336l1.616-2.478.538.35-1.618 2.478zM22.828 24.192l1.603-2.487.538.347-1.603 2.487zM3.806 12.111 7.35 6.686l.538.35-3.544 5.426zM6.284 18.28l.472-.306 3.478 5.372-.468.306z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2 18.786c1.54 0 2.8-1.261 2.8-2.8 0-1.54 1.26-2.8 2.8-2.8 1.54 0 2.8 1.26 2.8 2.8 0-3.08-2.52-5.6-5.6-5.6-3.08 0-5.6 2.52-5.6 5.6 0 1.54 1.26 2.8 2.8 2.8z",
    fill: "url(#fx9zvvi59b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8 13.186a2.81 2.81 0 0 0-2.8 2.8c0 1.539-1.26 2.8-2.8 2.8a2.81 2.81 0 0 1-2.8-2.8c0 3.079 2.52 5.6 5.6 5.6 3.08 0 5.6-2.521 5.6-5.6 0-1.54-1.26-2.8-2.8-2.8z",
    fill: "url(#yvlt759fnc)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKr);
export default __webpack_public_path__ + "static/media/kr.f7246d004e02bee1766a9a6c3d15af63.svg";
export { ForwardRef as ReactComponent };